import React, {useEffect, useState} from 'react';
import {Carousel} from 'antd';
import advertisementImg from "../resource/ad.png";
import http from "../framework/http";
import {useNavigate} from "react-router-dom";
import {observer} from "mobx-react-lite";
import categoryStore from "../store/Category.Store";

function Home() {
    const navigate = useNavigate();
    const [carouselContent, setCarouselContent] = useState();
    useEffect(() => {
        async function loadCarousel() {
            const res = await http.get("/slide/list");
            if (res.data && res.data.code === 200) {
                const slides = res.data.data;
                let imgArr = [];
                slides.map((slide) => {
                    const img = <img key={slide.id} src={http.getUri() + slide.picture} alt="" style={{width: "100%"}}/>;
                    imgArr.push(slide.url
                        ? <a key={slide.id} href={slide.url} target="_blank" rel="noreferrer">{img}</a>
                        : img
                    );
                });
                setCarouselContent(imgArr);
            }
        }
        loadCarousel();
    }, []);


    return (
        <div>
            <img src={advertisementImg} alt=""/>
            <Carousel>
                <Carousel autoplay>
                    {carouselContent}
                </Carousel>
            </Carousel>
            {/* Category Navigation */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))',
                gap: '16px 8px',
                padding: '20px 12px',
                backgroundColor: '#fff'
            }}>
                {Array.from(categoryStore.getCategory()?.values() || [])
                    .filter(category => category.parentId === 0)
                    .map(category => (
                        <div
                            key={category.id}
                            onClick={() => {
                                navigate(`/category/${category.id}`);
                            }}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '8px',
                                cursor: 'pointer'
                            }}
                        >
                            <div style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '16px',
                                backgroundColor: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden'
                            }}>
                                <img
                                    src={category.picture ? http.getUri() + category.picture : http.getUri() + "images/default.png"}
                                    alt={category.name}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>
                            <span style={{
                                fontSize: '13px',
                                fontWeight: 'bold',
                                color: '#333',
                                textAlign: 'center',
                                width: '100%',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                lineHeight: '1.2em',
                                maxHeight: '2.4em',
                                whiteSpace: 'normal'
                            }}>
                                {category.name}
                            </span>
                        </div>
                    ))}
            </div>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9530.68141306336!2d-6.3599224!3d53.3312554!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5783e2c0eea7a86d!2sDublin%20Computer%20Wholesale%20LTD!5e0!3m2!1sen!2sie!5m2!1sen!2sie"
                width="100%" height="450" style={{border: 0}} allowFullScreen=""/>
        </div>
    );
}

export default observer(Home);
